import type {ConversationComment} from '../../../page-data/payloads/conversation-comments'

/** User-facing name for each type of `ConversationComment`. */
export function itemTypeName(item: ConversationComment): {lowercase: string; capitalized: string} {
  switch (item.type) {
    case 'issue':
      return {
        lowercase: 'comment',
        capitalized: 'Comment',
      }
    case 'review_summary':
      return {
        lowercase: 'review',
        capitalized: 'Review',
      }
  }
}
